import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SousMenuPictos {

  constructor(){
    this.component = document.querySelector('[data-component="sous-menu-pictos"]');
    this.swiper = null;
    
    if( this.component){
      if(!Foundation.MediaQuery.atLeast('large')){
        this._init();
      }

      jQuery(window).on('changed.zf.mediaquery', (event, newSize, oldSize)=> this.updateSlider(event, newSize, oldSize));
      // window.addEventListener('changed.zf.mediaquery', (event, newSize, oldSize)=> this.updateSlider(event, newSize, oldSize));
    } 

  }

  _init(){
    this.trigger = this.component.querySelector('[data-trigger="sous-menu-pictos"]');

    this.swiper = new Swiper(this.trigger, {
      slidesPerView: 'auto',
      navigation: {
        nextEl: this.component.querySelector('[data-trigger="sous-menu-pictos-next"]'),
        prevEl: this.component.querySelector('[data-trigger="sous-menu-pictos-prev"]'),
      },
      // centeredSlides: true,
      // spaceBetween: 40,
    });
  }

  updateSlider(event, newSize, oldSize){
    console.log('event', event, 'newSize', newSize, 'oldSize', oldSize, this.swiper);
    if(oldSize === 'medium' && newSize === 'large' && this.swiper){
      this.swiper.destroy();
    }else if(oldSize === 'large' && newSize === 'medium' && !this.swiper){
      this._init();
    }
  }
}

export const sousMenuPictos = new SousMenuPictos();